import { createStore } from "redux";
import rootReducer from "./Reducer";

const initialState = {
  Header: "Home",
  emailVerification: null,
  userName: [],
  addLinkedinStep: [],
  addModalStep: [],
  addNewCampaign: {},
  stepName: "",
  isEditMode: false,
  id: 0,
  offset: 0,
  formData: [],
  selectDateResponse: undefined,
  campaignId: undefined,
  customerFilter: "",
  campaignDetail: null,
  campaignWorkflowClickType: ""
};

const store = createStore(rootReducer, initialState);
export default store;
